var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rejected-orders-table',{attrs:{"loading":_vm.loading,"rejected-orders":_vm.orders},on:{"updateList":_vm.fetchRejectOrder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }